import React, { ComponentType, useContext } from 'react';
import { ErrorBoundary } from '@sentry/react';
import styled from 'styled-components';
import TranslationContext from './TranslationContext';
import { ITranslations } from '../../interfaces/ITranslationFields';

type WithTranslationsProps = {
  translations?: ITranslations;
};

const ErrorWrapperStyled = styled.p`
  margin: auto;
  color: red;
  text-align: center;
  padding: 20px;
`;

const withTranslations = <P extends object>(WrappedComponent: ComponentType<P>): ComponentType<P & WithTranslationsProps> => {
  const WithTranslations: React.FunctionComponent<P & WithTranslationsProps> = props => {
    const translations = useContext(TranslationContext) as ITranslations;

    return (
      <ErrorBoundary fallback={<ErrorWrapperStyled>{translations.contentCannotBeDisplayed}</ErrorWrapperStyled>}>
        <WrappedComponent {...props} translations={translations}/>
      </ErrorBoundary>
    );
  };

  return WithTranslations;
};

export default withTranslations;
